// Common
import connect from '../../../../store/connect';
import connectOctopus from '../../../../store/connect-octopus';
import { getEnhance, FEATURE_NAME, namespace } from './gallery';
import experimentSelector from '../../../../components/experiment-selector';
import * as actions from '../../../../actions/vip';

// Component
import GalleryWrapper from '../../../../components/gallery';
import jsonToPropsComponent from '../../../../components/gallery/json-to-props';

// ComponentWithExperiment
import { withPlugins } from '../../../../utils/octopus';
import {
  GalleryMobile,
  PluginClipsMobile as clipsPlugin,
  PluginBookmarkMobile as bookmarkPlugin,
  PluginShareMobile as sharePlugin,
  PluginVisMobile as visPlugin,
} from '../../../../components/gallery-with-plugins/gallery.mobile';
import jsonToPropsWithExperiment from '../../../../components/gallery-with-plugins/helpers/json-to-props';

const SHARE = 'share';
const BOOKMARK = 'bookmark';
const WISHLIST_SAVE_BUTTON = 'wishlist_save_button';

const mapStateToProps = jsonToProps => (state, ownProps) => {
  const {
    [FEATURE_NAME]: gallery,
    [SHARE]: share,
    [BOOKMARK]: bookmark,
    [WISHLIST_SAVE_BUTTON]: wishlist,
    header: { title },
  } = state.components;

  const { csrfToken } = state;

  return {
    ...jsonToProps({ bookmark, csrfToken, share, ...gallery, titleForAlt: title, app: 'vip', wishlist }),
    ...ownProps,
  };
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  removeElementFromList: element => dispatch(actions.removeElementFromList(element)),
  addElementToList: element => dispatch(actions.addElementToList(element)),
  onClickBookmark: e => {
    e.preventDefault();
    return dispatch(actions.toggleBookmark());
  },
  showSnackbar: props => dispatch(actions.showSnackbar({ ...props })),
  openWishlistModalBS: () => dispatch(actions.openWishlistModalBS()),
  closeWishlistModalBS: isBookmarked => dispatch(actions.closeWishlistModalBS(isBookmarked)),
  updateGiftRegistry: check => dispatch(actions.fetchUpdatedWishlists(check)),
  toggleGiftRegistryCheckbox: check => dispatch(actions.toggleGiftRegistryCheckbox(check)),
  fetchBookmark: () => dispatch(actions.fetchBookmark()),
});

const enhance = getEnhance(
  connect(
    mapStateToProps(jsonToPropsComponent),
    mapDispatchToProps,
  ),
);

const enhanceWithExperiment = getEnhance(
  connectOctopus(
    mapStateToProps((...args) => ({
      ...jsonToPropsWithExperiment(...args),
      namespace,
    })),
    mapDispatchToProps,
  ),
);

const Component = enhance(GalleryWrapper);

const ComponentWithExperiment = enhanceWithExperiment(
  withPlugins(clipsPlugin, visPlugin, bookmarkPlugin, sharePlugin)(GalleryMobile),
);

export default experimentSelector({
  experimentName: 'octopus-gallery-plugin',
  Component,
  ComponentWithExperiment,
});
